import React from "react";
import { Collapse, useTheme, Box, Typography, Grid, Chip } from "@mui/material";
import { Check } from "@mui/icons-material";
import { Step, setStyle, useStyle } from "../../../state/map";
import { MapStyle } from "../../../types";
import { StyleInfo } from "../constants";
import { SectionTitle } from "./SectionTitle";
import StyleIcon from '@mui/icons-material/FormatPaint';
import { StepProps } from "./types";
import { useAppDispatch } from "@/state/types";

export const StyleStep = ({ expanded }: StepProps) => {
  const dispatch = useAppDispatch();
  const mapStyle = useStyle();
  const { palette } = useTheme();
  const onChange = (style: MapStyle) => {
    dispatch(setStyle(style));
  };
  const freeStyles = [MapStyle.NATURAL, MapStyle.LIGHT, MapStyle.DARK];
  const styleOptions = Object.values(MapStyle)
    .map((style) => ({
      label: StyleInfo[style].name,
      value: style,
      color: StyleInfo[style].color,
      isFree: freeStyles.includes(style),
    }))
    .sort((a, b) => {
      // Sort free styles first
      if (a.isFree && !b.isFree) return -1;
      if (!a.isFree && b.isFree) return 1;
      return 0;
    });
  return (
    <>
      <SectionTitle
        icon={StyleIcon}
        primary="Style"
        secondary="Personalise your map style"
        step={Step.Style}
      />
      <Collapse in={expanded} sx={{ pl: 2, py: 2, borderBottom: `${palette.primary.dark} solid 2px` }} unmountOnExit>
        <Grid container spacing={2}>
          {styleOptions.map((style) => (
            <Grid item xs={6} sm={4} md={4} key={style.value}>
              <Box
                onClick={() => onChange(style.value)}
                sx={{
                  p: 2,
                  borderRadius: '12px',
                  border: '2px solid',
                  borderColor: mapStyle === style.value ? 'primary.main' : 'divider',
                  bgcolor: mapStyle === style.value ? 'action.selected' : 'transparent',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateY(-2px)',
                    boxShadow: 2
                  }
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: 60,
                    borderRadius: '8px',
                    bgcolor: style.color,
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {mapStyle === style.value && (
                    <Check sx={{ color: 'white', fontSize: 24 }} />
                  )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'center' }}>
                    {style.label}
                  </Typography>
                  {style.isFree && (
                    <Chip 
                      label="Free" 
                      size="small" 
                      color="success"
                      sx={{ 
                        height: '18px', 
                        fontSize: '0.65rem', 
                        fontWeight: 600,
                        borderRadius: '4px'
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Collapse>
    </>
  );
};
